export default __webpack_public_path__ + "static/media/bg-small-blue.0a70f642.svg";